export default __webpack_public_path__ + "ee4c57fd96cb39284d6dffafc4814b49.png";